import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService, AppSettings, Agents, AuthenticationService } from '../services/_services';

@Component({
    selector: 'app-layout',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss']
})
export class PageComponent implements OnInit {

    public LeadLoader     : any = false;
    public loggedAgent    : any = [];
    public showAlerts     : any = false;

    constructor(
      public router                  : Router,
      private helperService          : HelperService,
      private agentsService          : Agents,
      private authenticationService  : AuthenticationService,
    ) {
        this.loggedAgent = this.authenticationService.get_currentUserValue();

        if(this.loggedAgent.user.id == '2147' || this.loggedAgent.user.id == '712' || this.loggedAgent.user.id == '2807' || this.loggedAgent.user.id == '2769' || this.loggedAgent.user.id == '2861')
          this.showAlerts = true;
        else
          this.showAlerts = false;
    }

    ngOnInit() {
      // If agents are not set get them
      if(!this.agentsService.getAgents())
        this.getAgents();
    }

    getAgents(){
      let url = AppSettings.API_ENDPOINT + "admin/get-agents";
      this.helperService.httpGetRequests(url).then(resp => {
        if(typeof resp != "undefined") {
          if(resp.data)
            this.agentsService.setAgents(resp.data);
        }
      });
    }
}
